import { render } from "./CodeReview.vue?vue&type=template&id=cb5860d8&scoped=true"
import script from "./CodeReview.js?vue&type=script&lang=js"
export * from "./CodeReview.js?vue&type=script&lang=js"

import "./CodeReview.vue?vue&type=style&index=0&id=cb5860d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5860d8"]])

export default __exports__